var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 156,
    viewBox: "0 0 156 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.301 82.8701H108.486V95.461H128.301V82.8701Z",
    stroke: "#0E171E",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.645 95.4609H114.378V105.106H135.645V95.4609Z",
    stroke: "#0E171E",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.207 105.106H106.59V120.925H131.207V105.106Z",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.804 95.461V82.8691",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.911 105.106V95.4595",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M121.037 120.925V105.062",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.404 117.213V109.021",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.239 105.187C122.961 106.518 124.683 107.85 126.405 109.182C128.005 107.823 129.606 106.465 131.207 105.106",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M121.037 120.925C122.826 119.594 124.615 118.262 126.404 116.93C128.005 118.262 129.606 119.594 131.207 120.925",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M108.405 85.0492C108.432 84.3446 108.459 83.6401 108.486 82.9355C111.95 82.9608 115.414 82.986 118.877 83.0112C115.387 83.6905 111.896 84.3698 108.405 85.0492Z",
    fill: "#0E171E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.398 97.7208C114.425 97.0163 114.452 96.3118 114.479 95.6072C117.277 95.5988 120.075 95.5904 122.873 95.582C120.048 96.295 117.223 97.0079 114.398 97.7208Z",
    fill: "#0E171E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.529 107.325C106.556 106.621 106.583 105.916 106.61 105.212C109.408 105.203 112.206 105.195 115.004 105.187C112.179 105.899 109.354 106.612 106.529 107.325Z",
    fill: "#0E171E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.188 107.467H109.031V110.029H113.188V107.467Z",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9854 94.9175V109.968",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6975 120.214C44.1307 121.249 45.7996 121.793 47.7021 121.793H90.1559C94.97 121.793 98.8726 117.891 98.8726 113.076V45.8318C98.8726 39.757 103.678 34.7703 109.748 34.545L47.7021 34.5034C42.888 34.5034 38.9854 38.406 38.9854 43.2202V71.9977",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118.898 50.8078V43.5842C118.898 38.5806 114.842 34.5244 109.838 34.5244C104.835 34.5244 100.778 38.5806 100.778 43.5842V69.3308H115.79H124.886C128.22 69.3308 130.924 66.6275 130.924 63.2927V50.8078H118.898Z",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.11,
    d: "M117.625 40.26C117.791 40.6405 117.921 40.9853 118.015 41.2583C117.028 41.3407 116.144 41.9177 115.675 42.8043C113.166 47.5553 109.453 54.1783 106.365 59.6175C104.822 62.3362 103.436 64.7577 102.435 66.4995C102.182 66.9406 101.953 67.3381 101.753 67.6858V43.9961C101.886 39.8181 104.141 36.1908 107.685 35.2499L107.557 34.7667L107.685 35.2499C110.577 34.4824 113.717 35.419 115.791 37.435C116.612 38.2326 117.219 39.3325 117.625 40.26Z",
    fill: "#0E171E",
    stroke: "#0E171E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6823 44.0889H50.2844C50.0389 44.0889 49.8398 44.2879 49.8398 44.5334V56.9313C49.8398 57.1768 50.0389 57.3758 50.2844 57.3758H62.6823C62.9278 57.3758 63.1268 57.1768 63.1268 56.9313V44.5334C63.1268 44.2879 62.9278 44.0889 62.6823 44.0889Z",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9814 50.7941L52.9813 50.7941M52.9814 50.7941L52.9813 50.794C52.9813 50.794 52.9813 50.794 52.9813 50.7941M52.9814 50.7941C52.9814 50.7941 52.9813 50.7941 52.9813 50.7941M52.9814 50.7941L52.9813 50.7941",
    fill: "#6AD67D",
    stroke: "#6AD67D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2607 49.1333H84.3945",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3418 51.7158H84.2746H69.3418Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3418 51.7158H84.2746",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8378 77.8662H74.8984",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1607 103.976H70.0293",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6406 81.1349V74.6104",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4632 45.8138C99.4632 40.9073 102.741 36.7438 107.257 35.4401C103.422 37.2988 100.883 41.1875 100.883 45.8138V113.054C100.883 116.761 98.4275 119.895 95.0546 120.919C97.6987 119.298 99.4632 116.382 99.4632 113.054V45.8138Z",
    fill: "#0E171E",
    stroke: "#0E171E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M118.898 47.6802L118.884 63.1234C118.881 66.5507 121.658 69.3308 125.085 69.3308",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5849 93.5897L31.3415 101.567C29.1108 103.427 25.7905 103.108 23.9548 100.857C22.1368 98.6275 22.4655 95.3473 24.6899 93.5231L39.0094 81.7798",
    stroke: "#0E171E",
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5486 67.2046L60.0938 77.5905",
    stroke: "#0E171E",
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2588 71.7343L75.436 51.9067C78.9308 53.0781 80.7609 55.8903 81.7449 59.5364L73.8143 66.1496",
    stroke: "#0E171E",
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8958 59.6075C82.7101 57.0247 83.4599 54.2986 84.2742 51.7158C81.195 51.7158 78.42 51.8278 75.3408 51.8278C76.2236 52.1364 77.806 52.8169 79.455 54.6983C81.1018 56.5772 81.705 58.692 81.8958 59.6075Z",
    fill: "#0E171E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0752 118.55L33.5273 109.547L30.6266 118.601L29.0752 118.55Z",
    fill: "#0E171E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2022 120.273L30.3184 120.128C30.5591 119.102 30.8271 118.052 31.1251 116.98C31.8774 114.282 32.73 111.786 33.6256 109.496C38.0663 109.826 42.5056 110.154 46.9449 110.483C45.009 105.369 41.6372 96.4618 40.0252 92.2031C41.547 95.3097 44.741 97.4477 48.4337 97.4477H53.0965L53.3215 97.6096C54.4435 100.874 55.567 104.138 56.6904 107.402L56.6961 107.424",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8882 118.617C29.4715 118.636 29.7492 118.646 30.6734 118.665C31.541 115.659 32.7574 112.493 33.6251 109.486C32.1017 109.274 31.6295 109.222 30.1061 109.01C29.3624 110.915 28.6451 112.55 27.9014 114.454",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2119 97.3594C49.6077 98.4878 52.0035 99.6162 54.3994 100.745C53.9725 99.6426 53.5457 98.5406 53.1189 97.4386C51.1499 97.4122 49.1809 97.3858 47.2119 97.3594Z",
    fill: "#0E171E"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3467 115.457H48.786C51.4644 115.457 53.3194 112.783 52.3815 110.274C50.7727 105.971 49.1639 101.667 47.5551 97.3638",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0755 118.734L26.9016 119.619C27.3785 120.13 28.2222 119.989 28.5071 119.35L29.2594 117.665C29.5588 116.994 29.4419 116.21 28.9597 115.656L27.8807 114.504L30.1816 109.038L24.6234 108.47C24.6234 108.47 21.9943 114.859 19.793 119.787L26.0755 118.734Z",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8117 115.715L24.4902 118.811",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5996 118.558L26.7224 115.928",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2962 114.726C24.17 115.099 24.576 116.109 24.203 116.983L23.1318 119.493C22.7589 120.367 21.7482 120.773 20.8744 120.4L19.7676 119.927L22.231 114.271L23.2962 114.726Z",
    fill: "#0E171E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8896 114.957L24.6233 108.47L25.5939 108.569L22.7188 115.311L21.8896 114.957Z",
    fill: "#0E171E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3043 108.836C28.3043 108.836 27.2623 111.674 24.5605 110.035",
    stroke: "#0E171E",
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5224 87.3501H69.1905C73.4894 87.3501 76.2464 91.9241 74.2374 95.7257C71.2196 101.435 68.2032 107.145 65.1854 112.854L58.26 113.014L54.0772 113.112C54.9499 111.213 55.8225 109.313 56.6952 107.414C58.2227 104.088 59.7517 100.764 61.2806 97.4381H48.4328C44.7401 97.4381 41.5461 95.3001 40.0242 92.1935C39.4152 90.9526 39.0742 89.5568 39.0742 88.0809V87.3501H58.635",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3047 87.3496C44.5696 90.2686 47.0235 92.5555 50.0114 92.5555H67.3173C68.4948 92.5555 69.2513 93.8059 68.7047 94.8489L60.0909 112.972",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6517 116.428L52.6592 116.516C52.6592 116.516 53.5211 114.469 54.0765 113.089C57.3099 113.072 60.597 112.893 63.8304 112.876C63.6475 113.251 63.4514 113.627 63.2563 113.987",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3789 114.696L63.8298 112.899L54.0758 113.111L53.3789 114.696Z",
    fill: "#0E171E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2313 116.408L63.721 115.301C64.0038 114.661 63.5429 113.941 62.844 113.929L60.9982 113.899C60.2635 113.887 59.5886 114.302 59.2679 114.963L58.6327 116.408L52.7016 116.438L50.498 121.773C50.498 121.773 61.27 121.682 66.6661 121.773L63.2313 116.408Z",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5586 117.836H63.9249",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2567 116.914H60.3965",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6357 120.537C60.6357 119.587 61.4059 118.817 62.356 118.817H65.0847C66.0347 118.817 66.8049 119.587 66.8049 120.537V121.741L60.6357 121.695V120.537Z",
    fill: "#0E171E"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M61.401 121.74L50.498 121.772L50.9858 120.838H61.401V121.74Z",
    fill: "#0E171E"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1797 117.7C52.1797 117.7 55.2444 117.71 54.7975 120.839",
    stroke: "#0E171E",
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2696 68.8949C48.6179 69.4882 49.7085 69.2841 50.2361 69.1114C50.45 69.0413 50.6099 68.8629 50.6534 68.6421C50.8119 67.8361 50.8378 66.9809 50.7882 66.1532L51.2241 65.8166C51.3521 65.7178 51.3744 65.5333 51.2737 65.4067L50.6069 64.5691C50.3219 62.8376 49.8391 61.5145 49.8391 61.5145C49.8391 61.5145 43.6943 59.9567 44.6137 67.4393L43.6943 69.4738L48.572 70.1335L48.6557 69.3536",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7773 65.1079C45.8014 65.1854 45.8678 65.3625 46.0399 65.516C46.2107 65.6684 46.3924 65.7146 46.4721 65.73",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8906 65.9795C48.9221 66.0567 48.9998 66.2171 49.1705 66.3498C49.3788 66.5116 49.5981 66.5331 49.6796 66.537",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6562 64.3757C48.7608 64.6133 49.0165 64.7335 49.2379 64.6689C49.4148 64.6172 49.5479 64.454 49.5735 64.2563",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6561 61.5994C48.6561 61.5994 48.6561 63.0338 46.9627 62.7049C46.7255 62.6588 46.4902 62.8048 46.4293 63.0386C46.3413 63.3765 46.3579 63.9125 46.8785 64.6129C46.8785 64.6129 46.9763 65.0464 46.1203 64.532C45.8598 64.3755 45.5335 64.3476 45.2666 64.493C44.963 64.6584 44.7202 65.0016 45.1078 65.7118C45.1078 65.7118 45.4483 66.2388 45.9421 66.4346L44.6311 67.5157C44.6311 67.5157 41.0133 63.0976 44.895 60.646C44.895 60.646 47.3466 59.1904 49.4663 60.1863C49.4663 60.1863 50.1378 60.5694 50.1047 61.1312C50.1047 61.1312 50.0039 61.9782 48.6561 61.5994Z",
    fill: "#0E171E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M68.664 87.3202C68.6318 87.3994 65.7016 90.0017 63.1142 89.2873C61.7163 88.9013 59.5433 88.6291 58.7299 87.279C58.4734 87.276 58.4723 87.276 58.2158 87.2729C58.3741 87.5284 60.3193 90.5487 64.0472 90.7031C68.0458 90.8689 70.28 87.5793 70.3872 87.4153C69.8935 87.4096 69.1577 87.3259 68.664 87.3202Z",
    fill: "#0E171E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M27.085 91.559L27.1161 89.4352C27.1321 88.3472 27.4842 87.2907 28.1242 86.4107L37.6023 73.3792C38.8086 71.7207 40.8101 70.8344 42.8489 71.056L43.568 69.3535L48.65 70.044L48.4712 71.4486C51.3923 71.5265 54.8826 72.7226 56.9902 74.7466L63.642 81.1348L68.3938 74.0221L73.5847 78.6683L69.526 85.9255C67.5547 89.4505 62.9447 90.4581 59.6824 88.0773L54.3998 84.2219V87.3495H38.9967L39.0096 81.7797L27.085 91.559Z",
    fill: "#6AD67D",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0752 85.0239L54.3998 85.2812",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4268 87.3493V85.0835",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6677 87.3493C42.6529 86.5281 42.6417 85.9047 42.627 85.0835",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2031 87.3494C51.2082 86.5844 51.2117 86.0463 51.2168 85.2812L51.2031 87.3494Z",
    fill: "#0E171E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2031 87.3494C51.2082 86.5844 51.2117 86.0463 51.2168 85.2812",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3984 87.3494C52.3782 86.637 52.4187 85.9937 52.3984 85.2812",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6123 80.7866C51.8748 81.9317 53.1373 83.0768 54.3999 84.2218",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6711 82.2848C64.2456 81.8222 63.8201 81.3596 63.3945 80.897",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0098 81.7794V79.3149",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2803 76.3827C74.842 75.5458 75.1337 75.0069 75.6726 73.8857C76.1669 72.8575 76.3498 72.5005 76.4596 72.0546C76.6108 71.4402 76.9045 70.2473 76.278 69.1944C76.0341 68.7846 75.7549 68.5314 75.5371 68.3745",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M75.188 71.5552C75.3764 71.194 76.1194 69.6743 75.4755 68.2259C75.3833 68.0186 75.2513 67.787 75.0586 67.5508",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5676 70.6017C74.6616 70.4239 75.7439 68.3048 74.7038 66.7427C74.556 66.5206 74.2414 66.0885 73.8135 66.0137",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5842 70.0117C73.7994 69.6071 74.069 68.9714 74.129 68.1654C74.2282 66.8328 73.7249 65.4316 73.3421 65.4415C73.1035 65.4476 73.0668 65.9973 72.4189 67.5147C71.66 69.2922 71.273 69.5619 70.951 69.6334C70.5626 69.7195 70.1896 69.5345 69.946 69.3747C69.7436 69.5435 69.5413 69.7123 69.3389 69.881C69.4677 70.1529 69.5946 70.4888 69.6787 70.8833C69.7758 71.3388 69.7926 71.7636 69.768 72.1378",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8965 69.3535L72.4322 67.3013L71.8095 68.8341C71.5565 69.4698 70.8253 69.7672 70.2004 69.4886L69.8965 69.3535Z",
    fill: "#0E171E"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3535 74.0813C68.7753 73.4159 69.1971 72.7504 69.6189 72.085C71.4904 73.8152 73.3619 75.5454 75.2334 77.2756C74.8413 77.86 74.4492 78.4443 74.0572 79.0286C72.156 77.3795 70.2547 75.7304 68.3535 74.0813Z",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4678 77.6142C72.8612 77.0039 73.1901 76.4937 73.5836 75.8833",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0264 76.3829C71.3997 75.7776 71.7729 75.1722 72.1462 74.5669",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4385 75.0219C69.8771 74.3959 70.3156 73.77 70.7542 73.144",
    stroke: "#0E171E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVat);
export default __webpack_public_path__ + "static/media/vat.dbb07b638c88d5c2815ed5a0c04541a5.svg";
export { ForwardRef as ReactComponent };